.card {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 22px;
  background: var(--accent);
  color: var(--accent-ink);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-button);
}

.heading {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.title {
  font-size: 20px;
}

.status {
  font-size: 15px;
}

/* The white button on the accent card, as drawn. */
.action {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 0 12px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  color: var(--ink);
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;
}
